import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useArchiveVault(id) {
  const queryClient = useQueryClient()

  const action = async ({
    new_income_default_vault,
    new_expense_default_vault,
    transfer_balance_to,
  }) => {
    return await httpClient.post(`team/vault/${id}/archive`, {
      new_income_default_vault,
      new_expense_default_vault,
      transfer_balance_to,
    })
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: (e) => {
      queryClient.invalidateQueries({
        queryKey: ['archive_vault'],
      })
      queryClient.invalidateQueries({
        queryKey: ['vaults'],
      })
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
      toast.success(e?.response?.data?.message ?? 'Vault has been archived')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
